module.exports = __webpack_public_path__ + "img/21090101.4b0bd2dc.jpg";